import React, { useEffect } from 'react';
import axios from 'axios';
import apiUrl from '../../Config';

const Details = () => {

  useEffect(() => {
    axios.get(apiUrl+'/employee/employee', { withCredentials: true })
      .then(response => {
        console.log(response.data);
        // You could also set the data to state here to display in the component
      })
      .catch(err => {
        console.error(err.response?.data || err);
      });
  }, []); // Empty dependency array means this runs once when the component mounts

  return (
    <div>Details</div>
  );
};

export default Details;
